<template>
  <div>
    <div class="row menubar">
      <button @click="windowPrint" style="float:right;">
        Print <awesomeIcon icon="print" />
      </button>
      <input type=text v-model="amount" placeholder="Vermogen" class="searchbar">
      <inputDropdown
        :array="durations"
        v-model="duration"
        style="float:right"
        displayPrefix="Duur: "
      />
      <inputDropdown
        :array="profiles"
        v-model="profile"
        displayPrefix="Profiel: "
        style="float:right"
        :defaultIndex="6"
      />
      <inputDropdown
        :array="brands"
        v-model="style"
        style="float:right"
        :cb="brandDropdownCB"
      />
    </div>
    <div class="card" id="result" v-if="results.length > 0">

      <div class="print">

      <img v-if="style == 'Velthuyse • Mulder'" width="250" src="../assets/vm/VM-logo3.svg" />
      <img v-if="style == 'Beer & Van Stapele'" width="250" src="../assets/bvs/BVS-logo3.svg" />
      <img v-if="style == 'OXBY'" width="100" src="../assets/ox/OX-logo1.svg" />

      <table>
        <tr>
          <td width="50%">Beheerd&nbsp;vermogen:&nbsp;
            <span id="vkm-result-vermogen">
              &euro; {{formatPrice(Number(amount), true)}},-
            </span>
          </td>
          <td width="50%">Bruto&nbsp;voorbeeld&nbsp;rendement:&nbsp;
            <span id="vkm-result-rendement">{{getProfileNumber()}}
            </span>%
          </td>
        </tr>
      </table>
      <table>
        <tr>
          <th width="50%">Onze&nbsp;dienstverlening</th>
          <th width="25%">&euro; {{formatPrice(results[0].onze, true)}}</th>
          <th width="25%">{{formatPrice(percentageOf(results[0].onze, results[0].prekosten))}}%</th>
        </tr>
        <tr>
          <td class="indent">Eenmalig</td>
          <td>&euro; 0</td>
          <td>0,00%</td>
        </tr>
        <tr>
          <td class="indent">Doorlopend</td>
          <td>&euro; {{formatPrice(results[0].beheervergoedingvast, true)}}</td>
          <td>
            {{formatPrice(percentageOf(results[0].beheervergoedingvast, results[0].prekosten))}}%
          </td>
        </tr>
        <tr>
          <td class="indent">Transacties</td>
          <td>&euro; {{formatPrice(results[0].transactiekosten, true)}}</td>
          <td>{{formatPrice(percentageOf(results[0].transactiekosten, results[0].prekosten))}}%</td>
        </tr>
        <tr>
          <td class="indent">Verwante&nbsp;diensten</td>
          <td>&euro; {{formatPrice(results[0].bewaarloon, true)}}</td>
          <td>{{formatPrice(percentageOf(results[0].bewaarloon, results[0].prekosten))}}%</td>
        </tr>
        <tr>
          <td class="indent">Incidenteel</td>
          <td>&euro; {{formatPrice(results[0].beheervergoedingvariable, true)}}</td>
          <td>
            {{formatPrice(
              percentageOf(results[0].beheervergoedingvariable, results[0].prekosten)
            )}}%
          </td>
        </tr>
        <tr>
          <th>Financi&euml;le&nbsp;instrumenten</th>
          <th>&euro; {{formatPrice(results[0].instrumenten, true)}}</th>
          <th>{{formatPrice(percentageOf(results[0].instrumenten, results[0].prekosten))}}%</th>
        </tr>
        <tr>
          <td class="indent">Eenmalig</td>
          <td>&euro; 0</td>
          <td>0,00%</td>
        </tr>
        <tr>
          <td class="indent">Doorlopend</td>
          <td>&euro; {{formatPrice(results[0].indirectekosten, true)}}</td>
          <td>{{formatPrice(percentageOf(results[0].indirectekosten, results[0].prekosten))}}%</td>
        </tr>
        <tr>
          <td class="indent">Transacties</td>
          <td>&euro; {{formatPrice(results[0].indirectetransactiekosten, true)}}</td>
          <td>
            {{formatPrice(
              percentageOf(results[0].indirectetransactiekosten, results[0].prekosten)
            )}}%
          </td>
        </tr>
        <tr>
          <td class="indent">Incidenteel</td>
          <td>&euro; 0</td>
          <td>0,00%</td>
        </tr>
        <tr>
          <th>Totaal</th>
          <th>&euro; {{formatPrice(results[0].calcvkm, true)}}</th>
          <th>{{formatPrice(percentageOf(results[0].calcvkm, results[0].prekosten))}}%</th>
        </tr>
      </table>
      <table>
        <tr>
          <th width="50%">Prognose:</th>
          <th width="25%">Bruto</th>
          <th width="25%">Netto</th>
        </tr>
        <tr v-if="duration == 3">
          <td>1&nbsp;jaar</td>
          <td>&euro; {{formatPrice(results[0].bruto, true)}}</td>
          <td>&euro; {{formatPrice(results[0].vermogen, true)}}</td>
        </tr>
        <tr v-if="duration == 3">
          <td>2 jaar</td>
          <td>&euro; {{formatPrice(results[1].bruto, true)}}</td>
          <td>&euro; {{formatPrice(results[1].vermogen, true)}}</td>
        </tr>
        <tr v-if="duration <= 10">
          <td>3&nbsp;jaar</td>
          <td>&euro; {{formatPrice(results[2].bruto, true)}}</td>
          <td>&euro; {{formatPrice(results[2].vermogen, true)}}</td>
        </tr>
        <tr v-if="duration == 5">
          <td>4&nbsp;jaar</td>
          <td>&euro; {{formatPrice(results[3].bruto, true)}}</td>
          <td>&euro; {{formatPrice(results[3].vermogen, true)}}</td>
        </tr>
        <tr v-if="duration != 3 && duration != 20">
          <td>5&nbsp;jaar</td>
          <td>&euro; {{formatPrice(results[4].bruto, true)}}</td>
          <td>&euro; {{formatPrice(results[4].vermogen, true)}}</td>
        </tr>
        <tr v-if="duration > 5">
          <td>10&nbsp;jaar</td>
          <td>&euro; {{formatPrice(results[9].bruto, true)}}</td>
          <td>&euro; {{formatPrice(results[9].vermogen, true)}}</td>
        </tr>
        <tr v-if="duration > 10">
          <td>15&nbsp;jaar</td>
          <td>&euro; {{formatPrice(results[14].bruto, true)}}</td>
          <td>&euro; {{formatPrice(results[14].vermogen, true)}}</td>
        </tr>
        <tr v-if="duration > 15">
          <td>20&nbsp;jaar</td>
          <td>&euro; {{formatPrice(results[19].bruto, true)}}</td>
          <td>&euro; {{formatPrice(results[19].vermogen, true)}}</td>
        </tr>
      </table>
      <p style="font-style:italic;">
        De bovenstaande tabel geeft een bruto en een netto prognose. In het overzicht is gerekend
        met een bruto voorbeeld rendement. Het daadwerkelijk gerealiseerd rendement kan hoger maar
        ook lager uitvallen. Het voorbeeld rendement biedt geen garantie op toekomstig rendement. De
        waarde van uw beleggingen kan fluctueren.In het verleden behaalde rendementen bieden geen
        garantie voor de toekomst.
      </p>
      </div>
      <div class="docdate">
        Vergelijkende Kosten
        Maatstaf {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy;
        <template v-if="style == 'Beer & Van Stapele'">
          Beer & Van Stapele Wealthmanagement
        </template>
        <template v-if="style == 'OXBY'">
          OXBY Vermogensbeheer
        </template>
        <template v-if="style == 'Velthuyse • Mulder'">
          Velthuyse &bull; Mulder Vermogensbeheer
        </template>
      </div>
      <div class="break" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'VKM',
  data() {
    return {
      amount: 50000,
      style: 'Velthuyse • Mulder',
      brands: [
        {
          value: 'Velthuyse • Mulder',
        },
        {
          value: 'Beer & Van Stapele',
        },
        {
          value: 'OXBY',
        },
      ],
      duration: 10,
      durations: [
        {
          label: '3 jaar',
          value: 3,
        },
        {
          label: '5 jaar',
          value: 5,
        },
        {
          label: '10 jaar',
          value: 10,
        },
        {
          label: '15 jaar',
          value: 15,
        },
        {
          label: '20 jaar',
          value: 20,
        },
      ],
      profile: '6% - Neutraal',
      results: [],
      today: new Date(),
      profiles: [
        {
          value: '0%',
        },
        {
          value: '1%',
        },
        {
          value: '2%',
        },
        {
          value: '3%',
        },
        {
          value: '4% - Zeer defensief',
        },
        {
          value: '5% - Defensief',
        },
        {
          value: '6% - Neutraal',
        },
        {
          value: '7% - Offensief',
        },
        {
          value: '8% - Zeer offensief',
        },
        {
          value: '9%',
        },
        {
          value: '10%',
        },
      ],
      profileDefaultValue: null,
    };
  },
  created() {
    this.calc();
  },
  watch: {
    amount() {
      this.calc();
    },
    style() {
      if (this.style == 'OXBY') {
        this.profiles = [
          {
            value: '0%',
          },
          {
            value: '1%',
          },
          {
            value: '2%',
          },
          {
            value: '3%',
          },
          {
            value: '4%',
          },
          {
            value: '5% - Laag',
          },
          {
            value: '6% - Midden',
          },
          {
            value: '7% - Hoog',
          },
          {
            value: '8%',
          },
          {
            value: '9%',
          },
          {
            value: '10%',
          },
        ];
      } else {
        this.profiles = [
          {
            value: '0%',
          },
          {
            value: '1%',
          },
          {
            value: '2%',
          },
          {
            value: '3%',
          },
          {
            value: '4% - Zeer defensief',
          },
          {
            value: '5% - Defensief',
          },
          {
            value: '6% - Neutraal',
          },
          {
            value: '7% - Offensief',
          },
          {
            value: '8% - Zeer offensief',
          },
          {
            value: '9%',
          },
          {
            value: '10%',
          },
        ];
      }

      this.calc();
    },
    profile() {
      this.calc();
    },
  },
  computed: {
    vkm() {
      if (this.style == 'OXBY') {
        return {
          minvermogen: 10000,
          maxvermogen: 1000000000,
          staffels: [ 0.85, 0.85, 0.85, 0.85 ],
          bewaarvariabel: 0,
          bewaarvast: 0,
          transkost: 0.075,
          transAantal: 1,
          transkostvast: 96,
          gemiddeldeTER: 0.3,
          gemiddeldeTrans: 0,
          weging: 100,
          beheervast: 0,
          tariefperc: 10,
        };
      }
      return {
        minvermogen: 50000,
        maxvermogen: 1000000000,
        staffels: [ 1.2, 1, 0.8, 0.6 ],
        bewaarvariabel: 0.04,
        bewaarvast: 200,
        transkost: 0.2,
        transAantal: 1,
        transkostvast: 0,
        gemiddeldeTER: 0.4,
        gemiddeldeTrans: 0.02,
        weging: 25,
        beheervast: 200,
        tariefperc: 10,
      };
    },
  },
  methods: {
    brandDropdownCB(newBrand) {
      if (newBrand.value === 'OXBY') {
        this.profile = '6% - Midden';
      } else {
        this.profile = '6% - Neutraal';
      }
    },
    getProfileNumber() {
      let numbers = [];
      let iterator = this.profile.trim();

      for (let i = 0; i < iterator.length; i++) {
        if (!isNaN(iterator.charAt(i))) {
          numbers.push(iterator.charAt(i));
        }
      }

      return Number(numbers.join(''));
    },
    percentageOf(amount, total) {
      return Math.round((amount / (total / 100)) * 100) / 100;
    },
    calc() {
      this.results = [];
      const staffels = [
        250000,
        500000,
        1000000,
        1000000000,
      ];
      var rendementperc = this.getProfileNumber();
      var vermogen = Number(this.amount);
      var bruto = Number(this.amount);
      for (let i = 1; i <= 20; i++) {
        let bewaarloon = (this.vkm.bewaarvariabel / 100) * vermogen + this.vkm.bewaarvast;
        var omzetsnelheid = 100;
        var transactiekosten = (omzetsnelheid / 50) * vermogen * (this.vkm.transkost / 100) + (Number(this.vkm.transkostvast) * Number(this.vkm.transAantal));
        var indirectekosten = (this.vkm.weging / 100) * vermogen * (this.vkm.gemiddeldeTER / 100);
        var indirectetransactiekosten = (this.vkm.weging / 100) * vermogen * (this.vkm.gemiddeldeTrans / 100);
        var staffelvalue = 0;
        var totalstaffel = 0;
        for (let staffel in staffels) {
          staffelvalue += (Math.min(staffels[staffel], vermogen) - totalstaffel) * (this.vkm.staffels[staffel] / 100);
          totalstaffel = staffels[staffel];
          if (vermogen <= staffels[staffel]) {
            break;
          }
        }
        var beheervergoedingvast = staffelvalue + this.vkm.beheervast;
        var rendement = (rendementperc / 100) * vermogen;
        var kosten = bewaarloon + transactiekosten + indirectetransactiekosten + indirectekosten + beheervergoedingvast;
        var beheervergoedingvariable = (Math.max(rendement - kosten, 0) / 100) * this.vkm.tariefperc;
        var beheervergoeding = beheervergoedingvast + beheervergoedingvariable;
        var calcvkm = bewaarloon + transactiekosten + indirectetransactiekosten + indirectekosten + beheervergoeding;

        var onze = bewaarloon + transactiekosten + beheervergoeding;
        var temp = vermogen + rendement;
        bruto += ((rendementperc / 100) * bruto);
        vermogen = vermogen + rendement - (calcvkm * 1);

        this.results.push({
          calcvkm,
          onze,
          instrumenten: indirectekosten + indirectetransactiekosten,
          bewaarloon,
          transactiekosten,
          indirectekosten,
          indirectetransactiekosten,
          beheervergoedingvariable,
          beheervergoedingvast,
          prekosten: temp,
          vermogen,
          bruto,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../scss/_paper.scss";
  .searchbar {
    width: 300px;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  table {
    border: 1px solid #ccc;
    margin-top: 30px;
    margin-bottom: 10px;
    th {
      background-color: #eee;
    }
    tr {
      background-color: #f9f9f9;
    }
  }
  .menubar {
    margin-bottom: 10px;
  }
</style>
